import React from "react";
import Checkbox from "@mui/material/Checkbox";

function FilterCheckboxRow({ id, label, checked, onChange }) {
  return (
    <div className="d-flex justify-content-between align-items-center pd-15 pd-b-5">
      <ul>
        <li htmlFor={id} className="mb-0">
          <b>{label}</b>
        </li>
      </ul>
      <Checkbox
        id={id}
        checked={checked}
        onChange={onChange}
        sx={{
          color: "#000",
          padding: 0,
          "&.Mui-checked": {
            color: "#000",
          },
        }}
      />
    </div>
  );
}

export default FilterCheckboxRow;
